import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FilterFieldComponent } from '../filter-field.component';
import { ItemsAndStatusFilterField } from './filter-field-items-and-status';

@Component({
  selector: 'va-filter-items-and-status',
  template: `
    <va-items-and-status
      (selection)="applyFilter($event)"
      [options]="filterField.options"
      [appliedSelection]="filterField.value"
      [itemConfig]="filterField.itemSelectorConfig"
      [statusConfig]="filterField.statusSelectorConfig"
      [closeSelectOnClick]="filterField.closeSelectOnClick"
    />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ItemsAndStatusFilterFieldComponent extends FilterFieldComponent<ItemsAndStatusFilterField> {
  newItemSelected(item: any): void {
    const statusOptions = this.filterField.statusOptionsForItem(item);
    let firstStatusOption = null;
    if (Array.isArray(statusOptions)) {
      firstStatusOption = statusOptions[0];
    }
    this.filterField.changeValue({ item: item, status: firstStatusOption });
  }

  itemMenuOptions(): any[] {
    return this.filterField.options.map((option) => option.item) || [];
  }
}
